import React, { useState, useEffect, useContext } from 'react';
import { IoChevronBackCircle } from "react-icons/io5";
import { IoIosAddCircle } from "react-icons/io";

import ConstantsService from '../../services/constants.service';
import WriteConstantRow from './writeConstantRow';
import ConstantRow from './constantRow';
//import AuthContext from 'store/AuthContext';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from 'components/common/skeleton/AppSkeleton';
import { AppTableNoData } from 'components/common/AppTableUtils';
import ToastContext from 'store/ToastContext';

export default function Constants(props) {
    //const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [edit, setEdit] = useState(false);
    const [data, setData] = useState([]);
    const [showAdd, setShowAdd] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 20, startIndex: 0, endIndex: 20 });
    
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = ()=> {
        setIsLoading(true);
        ConstantsService.getConstants()
        .then(data => {
                setData(data.sort((a, b) => a.constantName.localeCompare(b.constantName)));
                setIsLoading(false);
            }
        ).catch(err => {
                setData([]);
                setIsLoading(false);
            }
        )
    }

    const backhandler = () => {
        props.history.goBack();
    }

    const onRowUpdateSubmitted = async (values, action) => {
        setShowAdd(false);
        setEdit(false);
        setIsLoading(true);
        let actionResult;

        if (action === "delete") {
            actionResult = await ConstantsService.deleteConstant(values.id);
            if (actionResult === 0) {
                openToast("Constant deleted succesfully", "success");
                fetchData();
            } else {
                openToast("Error in deliting constant", "error");
                setIsLoading(false);
            }
        }
        if (action === "insert") {
           
            actionResult = await ConstantsService.addConstant(values);
            if (actionResult === 0) {
                openToast("Constant added succesfully", "success");
                fetchData();
            }            
            else {
                openToast("Error in adding constant", "error");
                setIsLoading(false);
            }
        }
        if (action === "update") {
          actionResult = await ConstantsService.updateConstant(values);
            if (actionResult === 0) {
                openToast("Constant updated succesfully", "success");
                fetchData();
            }         
            else {
                openToast("Error in updating constant", "error");
                setIsLoading(false);
            }
        }
        if (action === "closeLine") {
            setShowAdd(false);
            setIsLoading(false);
        }
    }

    const handleAddUserVisability = () => {
        setShowAdd(true);
    }


    return (
        <div className="container-fluid">
            <h2>Constants for Portal</h2>
            <div className="row mb-2">
                {showAdd ?
                <div className='col'>
                    <WriteConstantRow onSubmitted={onRowUpdateSubmitted} />
                </div> :
                <div className='col-md'></div>
                }
                <div className='col-auto'>
                    <AppButton classes="rightBtn" action={handleAddUserVisability} label="Add constant" icon={<IoIosAddCircle />}></AppButton>
                </div>
            </div>
            {isLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={4} variant="table" size="28px"/> : (
                <React.Fragment>
                    <div >
                        <div className="row align-items-c" style={{ background: "whitesmoke", padding: "15px" }}>
                            <div className="col-md-2" >ConstantName</div>
                            <div className="col-md-2" >ConstantValue </div>
                            <div className="col-md-6" >ConstantDescription </div>
                            <div className="col-md-2" >Actions</div>
                        </div>
                        {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                            return (
                                edit === item.id
                                    ? <WriteConstantRow key={item.id.toString()} constant={item} onSubmitted={onRowUpdateSubmitted} />
                                    : <ConstantRow key={item.id} item={item} onEdit={() => setEdit(item.id)} onSubmitted={onRowUpdateSubmitted} />
                            )
                        })}
                    </div>
                    {!data.length ? <AppTableNoData classes='mt-0'/> :
                            <AppPagination
                                pageSize={paginationObject.pageSize}
                                totalRecords={data.length}
                                currentPage={paginationObject.currPage}
                                endIndex={paginationObject.endIndex}
                                startIndex={paginationObject.startIndex}
                                setPaginationObject={(ele) => {
                                    setPaginationObject((data) => {
                                        return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                    })
                                }}
                            ></AppPagination>
                        }
                </React.Fragment>)
            }
            <AppButton action={backhandler} label="Back" icon={<IoChevronBackCircle />}></AppButton>
        </div>
    )
}